/**
 * UnlockLandmark applier.
 *
 * Records the chosen habitat in actionBudget for subsequent ChooseLandmarkCard.
 * Phase stays "unlockLandmark".
 *
 * Spec §9.2: "UnlockLandmark { habitat } then ChooseLandmarkCard { cardId }".
 * This applier just narrows the eligible habitats to the one chosen.
 *
 * Spec §9.2.
 */

import type { UnlockLandmarkAction } from "../types/actions";
import type { GameState } from "../types/game-state";
import { bumpVersion } from "./common-applier";

export const applyUnlockLandmark = (
  state: GameState,
  action: UnlockLandmarkAction,
): GameState => ({
  ...state,
  ...bumpVersion(state),
  turn: {
    ...state.turn,
    // Phase stays unlockLandmark; narrow eligible habitats to the chosen one
    actionBudget: {
      ...state.turn.actionBudget,
      landmarkEligibleHabitats: [action.habitat],
    },
  },
});
